import { gql } from 'graphql-tag';

export default gql`
  query GetCustomersV3($input: GetCustomersV3Input!) {
    getCustomersV3(input: $input) {
      count
      results {
        id
        user_id
        first_name
        last_name
        email
        cellphone
        lifetime_value
        events_attended
        total_events
        attendance_rate
        average_per_event
        customer_since
        last_purchase_date
        segment
        segment_direction
        has_season_pass
        location_category
        distance_miles
      }
    }
  }
`;
